import { Box, Container, ContainerProps } from '@mui/material'
import { ReactNode } from 'react'

type Props = {
  children: ReactNode
  marginTop?: number
  marginBottom?: number
} & Partial<Pick<ContainerProps, 'maxWidth'>>

const Wrapper = ({
  children,
  maxWidth = 'md',
  marginTop = 3,
  marginBottom = 5
}: Props) => {
  return (
    <Container maxWidth={maxWidth}>
      <Box
        mb={marginBottom}
        sx={{
          // Add top padding to account for fixed AppBar + margin
          paddingTop: `calc(64px + ${marginTop * 8}px)`, // Standard AppBar height + margin
          '@media (max-width: 600px)': {
            paddingTop: `calc(56px + ${marginTop * 8}px)` // Mobile AppBar height + margin
          }
        }}
      >
        {children}
      </Box>
    </Container>
  )
}

export default Wrapper
